module.exports = __webpack_public_path__ + "static/media/highland-logo.032eeec9.svg";